import styled from "styled-components";

export const CheckoutPosWrapper = styled.section`
    width: 1112px;
    max-width: 100%;
    padding: 48px 20px;
    margin: 0 auto;

    .sales__checkout-header-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 24px;

        p {
            font-size: 1.063rem;
            margin-top: 16px;
        }
    }

    @media (max-width: 767px) {
        .sales__checkout-header-wrap {
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;
            p {
                margin-top: 6px;
            }
        }
    }
`;

export const PosGridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20.5px 20px;
    margin-top: 48px;

    @media (max-width: 1165px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const PosCardStyled = styled.div`
    border-radius: 8px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    padding: 20px 16px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: ${({ loadingStyled }) => (loadingStyled ? "not-allowed" : "pointer")};
    .sales__checkout-pos-item-bottom {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
    h6 {
        font-weight: 900;
        opacity: ${({ loadingStyled }) => loadingStyled && "0.3"};
    }
`;

export const PosIconWrap = styled.div`
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    background: ${({ bgColor }) => bgColor};
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ loadingStyled }) => loadingStyled && "0.3"};
`;

export const CardLoader = styled.div`
    /* position: absolute;
    right: 16px;
    bottom: 20px; */
    z-index: 1;
    width: 32px;
    height: 32px;
    /* margin: -76px 0 0 -76px; */
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #000;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
